<div *ngIf="element.url">
    <iframe width="300" height="510" style="max-width: 100%;" [src]="url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>